import { createSlice } from '@reduxjs/toolkit';

import { getPicklist, createPickList, getPutawayMaterials } from "../../apis";

export const pickingPackingPlatform = createSlice({
  name: "pickingPacking",
  initialState: {
    loading: false,
    error: "",
    getPicklistData: [],
    getPicklistMaterialsData: [],
    createPickListSuccess: false,
  },
  reducers: {
    clear: (state, action) => {
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };
    },
      setPutawayMaterialsData: (state, action) => {
        state.getPicklistMaterialsData = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getPicklist.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getPicklist.fulfilled, (state, action) => {
      state.loading = false;
      state.getPicklistData = action.payload.data;
    });
    builder.addCase(getPicklist.rejected, (state, action) => {
      state.error = action.payload.message;
      state.loading = false;
    });
    builder.addCase(getPutawayMaterials.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getPutawayMaterials.fulfilled, (state, action) => {
      state.loading = false;
      state.getPicklistMaterialsData = action.payload.data;
    });
    builder.addCase(getPutawayMaterials.rejected, (state, action) => {
      state.error = action.payload.message;
      state.loading = false;
    });

    builder.addCase(createPickList.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(createPickList.fulfilled, (state, action) => {
      state.loading = false;
      state.createPickListSuccess = true;
    });
    builder.addCase(createPickList.rejected, (state, action) => {
      state.error = action.payload.message;
      state.loading = false;
    });
  },
});

export const { clear, setPutawayMaterialsData } = pickingPackingPlatform.actions;

export default pickingPackingPlatform.reducer